// import { useEffect } from 'react';
import useFetchEffect from '@/hooks/useFetchEffect';
import {
  fetchDocumentsFromApi,
  fetchNotifications,
  fetchPropertiesDocumentStatistics,
  fetchPropertiesValueEstimates,
  getPropertyPriceHistories,
} from '@/api/properties';
import { fetchPropertyCompanyStats } from '@/api/propertyowners';
import { connect } from 'react-redux';
import { acSetUserNotifications } from '@/store/actions/notifications';
import { sGetUserNotifications } from '@/store/reducers/notifications';
import {
  acSetPropertyCompanyStats,
  acSetPropertyDocumentStatistics,
  acSetPropertyValueEstimates,
  acSetPropertyValueIncreases,
} from '@/store/actions/properties';
import {
  sGetActiveProperty,
  sGetPropertyCompanyStats,
  sGetPropertyDocumentStatistics,
  sGetPropertyValueEstimates,
  sGetPropertyValueIncreases,
} from '@/store/reducers/properties';
import {
  acSetDocuments,
  acSetFetchingDocuments,
} from '@/store/actions/documents';
import { useFetchDocuments } from '@/api/hooks';

const PropertyDataProvider = ({
  children,
  activeProperty,
  setDocuments,
  setFetchingDocuments,
  userNotifications,
  propertyValueIncreases,
  propertyValueEstimates,
  propertyDocumentStatistics,
  propertyCompanyStats,
  setPropertyValueIncreases,
  setPropertyValueEstimates,
  setPropertyDocumentStatistics,
  setPropertyCompanyStats,
  setUserNotifications,
}) => {
  const propertyDocuments = useFetchDocuments(activeProperty);

  useFetchEffect({
    setFetchingFunction: setFetchingDocuments,
    onSuccess: (data) => setDocuments(data),
    conditionFunction: () =>
      activeProperty?.boligmappaNumber && !propertyDocuments?.data,
    apiFetchFunction: () =>
      activeProperty && fetchDocumentsFromApi(activeProperty?.boligmappaNumber),
  });

  useFetchEffect({
    // setFetchingFunction: setPropertyCompanyStatsFetching,
    onSuccess: (data) => setUserNotifications(data.notifications),
    conditionFunction: () => !userNotifications,
    apiFetchFunction: () => fetchNotifications(),
  });

  useFetchEffect({
    // setFetchingFunction: setPropertyCompanyStatsFetching,
    onSuccess: (data) => setPropertyValueIncreases(data),
    conditionFunction: () => !propertyValueIncreases,
    apiFetchFunction: () => getPropertyPriceHistories(),
  });

  useFetchEffect({
    // setFetchingFunction: setPropertyCompanyStatsFetching,
    onSuccess: (data) => setPropertyValueEstimates(data),
    conditionFunction: () => !propertyValueEstimates,
    apiFetchFunction: () => fetchPropertiesValueEstimates(),
  });

  useFetchEffect({
    // setFetchingFunction: setPropertyCompanyStatsFetching,
    onSuccess: (data) => setPropertyDocumentStatistics(data),
    conditionFunction: () => !propertyDocumentStatistics,
    apiFetchFunction: () => fetchPropertiesDocumentStatistics(),
  });

  useFetchEffect({
    // setFetchingFunction: setPropertyCompanyStatsFetching,
    onSuccess: (data) => setPropertyCompanyStats(data),
    conditionFunction: () => !propertyCompanyStats,
    apiFetchFunction: () => fetchPropertyCompanyStats(),
  });
  return children;
};

const mapStateToProps = (state) => ({
  activeProperty: sGetActiveProperty(state),
  userNotifications: sGetUserNotifications(state),
  propertyValueIncreases: sGetPropertyValueIncreases(state),
  propertyValueEstimates: sGetPropertyValueEstimates(state),
  propertyDocumentStatistics: sGetPropertyDocumentStatistics(state),
  propertyCompanyStats: sGetPropertyCompanyStats(state),
});
const mapDispatchToProps = (dispatch) => ({
  setDocuments: (documents) => dispatch(acSetDocuments(documents)),
  setFetchingDocuments: (fetching) =>
    dispatch(acSetFetchingDocuments(fetching)),
  setUserNotifications: (data) => dispatch(acSetUserNotifications(data)),
  setPropertyValueIncreases: (data) =>
    dispatch(acSetPropertyValueIncreases(data)),
  setPropertyValueEstimates: (data) =>
    dispatch(acSetPropertyValueEstimates(data)),
  setPropertyDocumentStatistics: (data) =>
    dispatch(acSetPropertyDocumentStatistics(data)),
  setPropertyCompanyStats: (data) => dispatch(acSetPropertyCompanyStats(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PropertyDataProvider);
